import axios from 'axios';

export default axios.create({
    // LOCAL
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: true,
})